import { Filters, Travelers } from './search-body.model';
import Itinerary from './itinerary.model';
import CurrencyList from './currency-list.model';

export default class EstimateResult {
    public estimate: IEstimate = new Estimate();
}

export class Estimate implements IEstimate {
    estimate_id: string;
    itinerary_id: string;
    low_sale: string;
    max: { price: number; fares: Array<EstimateFare>; route: string; hubs: string; Y: number; C: number };
    min: { price: number; fares: Array<EstimateFare>; route: string; hubs: string; Y: number; C: number };
    rates: Record<string, number>;
    constructor() {
        this.estimate_id = "";
        this.itinerary_id = "";
        this.min = {
            price: 0,
            fares: [],
            route: "",
            hubs: "",
            Y: 0,
            C: 0,
        };
        this.max = {
            price: 0,
            fares: [],
            route: "",
            hubs: "",
            Y: 0,
            C: 0,
        };
        this.rates = {};
        this.low_sale = "";
    }
}

interface IEstimate {
    estimate_id: string
    itinerary_id: string,
    min: {
        price: number
        fares: Array<EstimateFare>
        route: string;
        hubs: string;
        Y: number;
        C: number;
    },
    max: {
        price: number
        fares: Array<EstimateFare>
        route: string;
        hubs: string;
        Y: number;
        C: number;
    }
    rates: Record<string, number>,
    low_sale: string
}

interface EstimateFare {
    route: string;
    price: number;
    cost: number;
    fallback: number;
}
